export const chartLegendOrder = {
  distributionOfInteractions: {
    'Curtidas/gostei': 2,
    'Comentários': 1,
    'Compartilhamento': 0,
  },
  socialNetwork: {
    facebook: 3,
    instagram: 2,
    twitter: 1,
    youtube: 0,
  },
  sentimentsInTheComments: {
    positivo: 3,
    neutro: 2,
    negativo: 1,
    'não classificado': 0,
  },
  publicationsOverTimeWithDistribution: {
    'Curtidas/gostei': 2,
    'Comentários': 1,
    'Compartilhamento': 0,
  },
  sentimentsInTheCommentsOverTime: {
    positivo: 0,
    neutro: 1,
    negativo: 2,
    'não classificado': 3,
  },
};
